import { defineMessages } from 'react-intl';

export const i18n: {
	jiraFilterProjectLabelSelected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	jiraFilterProjectLabelUnselected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	jiraFilterProjectPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	project: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	project: {
		id: 'dynamic-cards-search-page.filters.names.project',
		defaultMessage: 'Project',
		description: 'Label for filtering by project',
	},
	jiraFilterProjectPlaceholder: {
		id: 'dynamic-cards-search-page.jira.filter.project.placeholder',
		defaultMessage: 'Find projects',
		description: 'Placeholder for project filter search input',
	},
	jiraFilterProjectLabelSelected: {
		id: 'dynamic-cards-search-page.jira.filter.project.selected',
		defaultMessage: 'Selected',
		description: 'Jira project filter selected label',
	},
	jiraFilterProjectLabelUnselected: {
		id: 'dynamic-cards-search-page.jira.filter.project.unselected',
		defaultMessage: 'Suggested',
		description: 'Jira project filter unselected label',
	},
});
